<script setup lang="ts">
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useEvents } from '@/composables/useEvents'
import OrganizerLayout from '@/components/layout/OrganizerLayout.vue'

const { t } = useI18n()
const route = useRoute()

const eventSlug = route.params['eventSlug'] as string

const { event, fetchEvent } = useEvents()

const tabs = [
  { name: 'organizer.events.website.overview',   label: () => t('events.website.tab_overview') },
  { name: 'organizer.events.website.media',      label: () => t('events.website.tab_media') },
  { name: 'organizer.events.website.appearance', label: () => t('events.website.tab_appearance') },
]

onMounted(() => void fetchEvent(eventSlug))
</script>

<template>
  <OrganizerLayout>
    <main class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <!-- Breadcrumb -->
      <nav aria-label="breadcrumb" class="flex items-center gap-2 text-xs text-slate-500 mb-6 flex-wrap">
        <RouterLink to="/organizer/dashboard" class="hover:text-slate-300 transition-colors">
          {{ t('nav.sidebar.dashboard') }}
        </RouterLink>
        <span aria-hidden="true">/</span>
        <RouterLink to="/organizer/events" class="hover:text-slate-300 transition-colors">
          {{ t('nav.sidebar.events') }}
        </RouterLink>
        <span aria-hidden="true">/</span>
        <RouterLink :to="`/organizer/events/${eventSlug}`" class="hover:text-slate-300 transition-colors">
          <template v-if="event">{{ event.name }}</template>
          <span v-else class="text-slate-600">…</span>
        </RouterLink>
        <span aria-hidden="true">/</span>
        <span class="text-slate-300">{{ t('events.website.heading') }}</span>
      </nav>

      <!-- Heading -->
      <div class="mb-6">
        <h1 class="text-3xl font-bold text-white">
          <template v-if="event">{{ event.name }}</template>
          <span v-else class="text-slate-500">{{ t('events.website.heading') }}</span>
        </h1>
        <p class="text-slate-400 mt-1">{{ t('events.website.heading') }}</p>
      </div>

      <!-- Tab bar -->
      <div class="flex gap-1 border-b border-slate-700 mb-6">
        <RouterLink
          v-for="tab in tabs"
          :key="tab.name"
          :to="{ name: tab.name }"
          class="px-4 py-2.5 text-sm font-medium transition-colors border-b-2 -mb-px"
          :class="
            route.name === tab.name
              ? 'border-emerald-500 text-emerald-400'
              : 'border-transparent text-slate-400 hover:text-slate-200'
          "
        >
          {{ tab.label() }}
        </RouterLink>
      </div>

      <!-- Panel content -->
      <RouterView />
    </main>
  </OrganizerLayout>
</template>
